const LOG_PREFIX = `@wix/design-system: [WARNING] `;

const deprecationTestkitLog = message => {
  console.warn(`${LOG_PREFIX}${message}`);
};

export { deprecationTestkitLog };
